import Style from '../../style/element/loader/Loader.module.css'

export default function Loader(props:{width?:string,height?:string,borderTop?:string}){
    const {width="20px",height="20px",borderTop="1px"}=props

    return <>
    <div className={Style.loader} style={{ width:width,height:height,borderTop:`${borderTop} solid #3498db` }}></div>
</>
}